import { ErrorFallback as e } from "./ErrorFallback/ErrorFallback.mjs";
import { isStaleChunkError as t } from "./staleChunk/isStaleChunkError.mjs";
import { shouldAttemptRecoveryReload as n } from "./staleChunk/shouldAttemptRecoveryReload.mjs";
import { StaleChunkReloadFallback as r } from "./staleChunk/StaleChunkReloadFallback.mjs";
import { useState as i } from "react";
import { ErrorBoundary as a } from "@maat/store-error/react";
import { AppContext as o, ErrorLevel as s, getActiveApp as c } from "@maat/store-error";
import { useTranslation as l } from "@maat/store-i18n";
import { jsx as u } from "react/jsx-runtime";
//#region src/ErrorBoundary.tsx
var d = ({ variant: d = "page", app: f, vertical: p = "app", level: m, route: h, platform: g = { platform: "web" }, user: _, fingerprint: v, showDetails: y, title: b, description: x, icon: S, fallback: C, children: w }) => {
	let [T, E] = i(0), { t: D } = l("common"), O = f ?? c() ?? o.Guest, k = m ?? (d === "page" ? s.Fatal : s.Error), A = typeof window < "u" ? window.location.pathname : "", j = (n, r) => /* @__PURE__ */ u(e, {
		variant: d,
		error: n,
		componentStack: r?.componentStack,
		title: b ?? (t(n) ? D("errors.loadFailed.title") : void 0),
		description: x ?? (t(n) ? D("errors.loadFailed.description") : void 0),
		icon: S,
		showDetails: y,
		onRetry: d === "page" ? void 0 : () => E((e) => e + 1)
	});
	return /* @__PURE__ */ u(a, {
		context: {
			app: O,
			level: k,
			vertical: p
		},
		location: {
			pageUrl: A,
			route: h
		},
		platform: g,
		user: _,
		fingerprint: v,
		fallback: C ?? ((e, t) => n(e) ? /* @__PURE__ */ u(r, { renderDefault: () => j(e, t) }) : j(e, t)),
		children: w
	}, T);
};
//#endregion
export { d as ErrorBoundary };
